// import { sumoLogger } from '../../sumoLogger';
// eslint-disable-next-line no-process-env, id-match
const { REACT_APP_BASE_URL } = process.env;

export const getEnvironment = (baseUrl) => {
	let env = null;

	if (baseUrl.includes('staging')) {
		env = 'DEV';
	} else if (baseUrl.includes('test')) {
		env = 'STG';
	} else {
		env = 'PROD';
	}

	return env;
};

export const initializePendo = (candidate, jobChatId) => {
	if (!window.pendo) {
		// sumoLogger.log({
		// 	error: {
		// 		message: 'Pendo Error: Failed To Initialize',
		// 		candidateId: candidate.id,
		// 		jobChatId,
		// 	},
		// });
	} else {
		const visitor = {
			id: candidate.id ? `JobChat-${candidate.id}` : 'JobChat-Form Bypassed',
			customerId: candidate.customerId ? candidate.customerId : 'Unable To Retrieve',
			jobChatId,
		};
		const account = {
			id: candidate.customerId ? `JobChat-${candidate.customerId}` : 'Form Bypassed',
			customerName: candidate.customerName ? candidate.customerName : 'Unable To Retrieve',
			product: 'job-chat',
		};

		window.pendo.initialize({ visitor, account });
	}
};

export const resumeUploadJobSearchPendo = (candidate, jobChatId) => {
	try {
		window.pendo.track('Candidate Uploaded Resume', {
			app: 'job-chat',
			customerId: candidate.customerId ? candidate.customerId : 'Unable To Retrieve',
			jobChatId,
			environment: getEnvironment(REACT_APP_BASE_URL),
		});
	} catch (err) {
		// sumoLogger.log({
		// 	error: err,
		// 	additionalInfo: {
		// 		message: 'Pendo Error: Failed To Track JobChat Resume Upload',
		// 		candidateId: candidate.id ? candidate.id : 'Form Bypassed',
		// 		customerId: candidate.customerId ? candidate.customerId : 'Unable To Retrieve',
		// 		jobChatId,
		// 	},
		// });
	}
};
